import { OverheadInput, OverheadsResponse } from "../../types";
import apiClient from "../apiClient";
import { OverheadFilters } from "./types.api";

export const getOverheads = async (
  params: OverheadFilters,
): Promise<OverheadsResponse> => {
  const response = await apiClient.get("overheads/getAll", { params });
  return response.data;
};

export const addOverhead = async (params: OverheadInput) => {
  await apiClient.post("overheads/addOverhead", params);
};

export const updateOverhead = async (
  params: Partial<OverheadInput> & { id: string },
) => {
  await apiClient.put("overheads/updateOverhead", params);
};

export const deleteOverhead = async (id: string) => {
  await apiClient.delete(`overheads/removeOverhead/${id}`);
};
